 $(document).ready(function() {
    function on() {
        document.getElementById("form_modal").style.display = "block";
// document.querySelector('.form_generater_form_div').style.border="none"
    }

    function off() {
        document.getElementById("form_modal").style.display = "none";
    }
    $('.modalBtn').on('click', function() {
        on();
        $('body').addClass('over--flow');
        $('body').find('div#shopify-section-sections--17611212128505__header').css('z-index', '999');
    });
    $('.close').on('click', function() {
        off();
        $('body').removeClass('over--flow');
        $('div#shopify-section-sections--17611212128505__header').css('z-index', '');
    });
    $(document).mouseup(function(e) {
        var elem = $('.modal-content');
        if (!elem.is(e.target) && elem.has(e.target).length == 0) {
            off();
            $('body').removeClass('over--flow');
            $('div#shopify-section-sections--17611212128505__header').css('z-index', '');
        }
    });
});

